import Button from 'src/components/button/Button';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import theme from 'src/components/themes/DefaultTheme';
import styled from 'src/lib/styles/css';
//#region [Styles]
const SWatchlistButton = styled(Button)`
	background: none;
	border: none;
	background-color: var(--buttoncolor);
	color: var(--buttontextcolor);
	display: inline-block;
	@media ${theme.mq.desktop} {
		//@media (orientation: landscape) {
		margin-left: 20px;
	}
`;

const SWatchlistSvg = styled(WatchlistSvg)`
	height: 16px !important;
	path {
		fill: var(--buttontextcolor) !important;
	}
`
//#endregion

//#region [Props]
type WatchlistButtonProps = {
	isWatchlisted: boolean;
	onWatchlistClick: () => void;
};
//#endregion

//#region [Component]
export default function WatchlistButton({ isWatchlisted, onWatchlistClick }: WatchlistButtonProps) {
	return <SWatchlistButton
		text='Legg i huskelisten'
		icon={<SWatchlistSvg selected={isWatchlisted} />}
		onClick={onWatchlistClick}
	/>;
}
//#endregion